import React from 'react';
import { motion } from 'framer-motion';
export function MethodSection() {
  const methodSteps = [{
    letter: 'R',
    title: 'Relajación',
    description: 'Calmar el cuerpo y salir del modo estrés para poder recibir'
  }, {
    letter: 'E',
    title: 'Escritura',
    description: 'Enfocar la mente en una verdad y una promesa del día'
  }, {
    letter: 'V',
    title: 'Visualización',
    description: 'Entrenar el interior para caminar en fe con dirección'
  }, {
    letter: 'E',
    title: 'Emoción elevada',
    description: 'Sostener paz, gratitud y esperanza como postura interna'
  }, {
    letter: 'L',
    title: 'Liberación',
    description: 'Soltar miedo, culpa y control; entregar el proceso a Dios'
  }, {
    letter: 'A',
    title: 'Acción inspirada',
    description: 'Un paso pequeño, real y obediente coherente con tu oración'
  }];
  return <section className="w-full bg-navy text-white py-16 md:py-24" data-id="element-223">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-225">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-gold mb-6 text-center" data-id="element-226">
            Un método simple. 10–15 minutos. Todos los días.
          </h2>

          <p className="text-lg text-white/90 mb-12 max-w-3xl mx-auto text-center" data-id="element-227">
            <strong data-id="element-228">R.E.V.E.L.A.</strong> es el método central del programa. No
            es una fórmula mágica ni una técnica de "pensamiento positivo": es
            una forma práctica y espiritual de{' '}
            <strong data-id="element-229">conectar con Dios</strong>, ordenar tu interior y sostener
            pasos pequeños con constancia. Integra fe bíblica con hábitos reales
            para llevar tu oración a la vida cotidiana, un día a la vez.
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-230">
            {methodSteps.map((step, index) => <motion.div key={step.letter} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white/10 rounded-lg p-6 backdrop-blur-sm" data-id="element-231">
                <div className="flex items-center gap-4 mb-3" data-id="element-232">
                  <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center" data-id="element-233">
                    <span className="text-navy font-bold text-xl" data-id="element-234">
                      {step.letter}
                    </span>
                  </div>
                  <h3 className="text-xl font-serif font-bold text-gold" data-id="element-235">
                    {step.title}
                  </h3>
                </div>
                <p className="text-white/80" data-id="element-236">{step.description}</p>
              </motion.div>)}
          </div>

          <div className="bg-gold/20 border-l-4 border-gold rounded-r-lg p-6 max-w-3xl mx-auto" data-id="element-237">
            <h3 className="text-xl font-serif font-bold text-gold mb-4" data-id="element-238">
              Ejemplo rápido
            </h3>
            <p className="text-white/90 mb-2" data-id="element-239">
              <strong data-id="element-240">Si hoy te preocupa el dinero:</strong>
            </p>
            <p className="text-white/80 leading-relaxed" data-id="element-241">
              Te detienes → respiras → escribes una promesa de provisión →
              visualizas paz en tus finanzas → sientes gratitud → sueltas el
              control a Dios → revisas 10 minutos tu presupuesto o das un paso
              concreto de mayordomía.
            </p>
            <p className="text-gold font-semibold mt-4" data-id="element-242">
              Eso es R.E.V.E.L.A. aplicado. Simple, bíblico y constante.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}